<template>
  <router-link
    :to="{ name: 'profile', params: { slug: user.slug }}"
    qid="user-dropdown-profile-link"
  >
    {{user.name}}
  </router-link>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js'
  import {config} from '@/config.js'

  export default {
    name: 'UserLink',
    props: {
      user: {
        type: Object,
        required: true
      },
      size: {
        type: String
      }
    },
    data: function() {
      return {
        styleObject: {},
      }
    },
    computed: {

    },
    methods: {
    },
    created () {
    }
  }
</script>
